/**
 * Ferment Bundle Picker
 * Pick exactly 3 jars (duplicates allowed), optional 4th.
 * Shows individual prices. Supports subscribe & save.
 */
(function () {
  'use strict';

  var MIN = 3;
  var MAX = 4;
  var SUBSCRIBE_DISCOUNT = 0.05;
  var SELLING_PLAN_ID = 690022056272;
  var selections = [];
  var picking4th = false;

  var picker, grid, counter, countEl, errorEl;
  var fourthWrap, fourthBtn, fourthHint;
  var purchaseType, optOnetime, optSubscribe, priceOnetime, priceSubscribe;
  var prop1, prop2, prop3, prop4;
  var clearBtn;
  var addToCartBtn;

  function money(v) { return '\u00A3' + parseFloat(v).toFixed(2); }

  function updateUI() {
    var n = selections.length;
    countEl.textContent = n;
    counter.classList.toggle('fk-counter--complete', n >= MIN);

    // Clear button visibility
    if (clearBtn) clearBtn.style.display = n > 0 ? '' : 'none';

    var buttons = grid.querySelectorAll('.fk-flavour');
    buttons.forEach(function (btn) {
      var flavour = btn.getAttribute('data-flavour');
      var count = selections.filter(function (s) { return s.name === flavour; }).length;

      btn.setAttribute('aria-pressed', count > 0 ? 'true' : 'false');
      btn.classList.toggle('fk-flavour--selected', count > 0);

      var badge = btn.querySelector('.fk-flavour__badge');
      if (count > 1) {
        badge.textContent = 'x' + count;
        badge.style.display = '';
      } else if (count === 1) {
        badge.textContent = '';
        badge.style.display = '';
      } else {
        badge.textContent = '';
        badge.style.display = 'none';
      }
    });

    prop1.value = selections[0] ? selections[0].name : '';
    prop2.value = selections[1] ? selections[1].name : '';
    prop3.value = selections[2] ? selections[2].name : '';
    prop4.value = selections[3] ? selections[3].name : '';

    // Sync to cart attributes so Flow can read them
    if (n >= MIN) {
      var attrs = {
        'Jar 1': selections[0] ? selections[0].name : '',
        'Jar 2': selections[1] ? selections[1].name : '',
        'Jar 3': selections[2] ? selections[2].name : ''
      };
      if (selections[3]) attrs['Jar 4'] = selections[3].name;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        credentials: 'same-origin'
      }).catch(function () {});
    }

    // 4th jar UI
    if (n === MIN && !picking4th) {
      fourthWrap.style.display = '';
      fourthBtn.style.display = '';
      fourthHint.style.display = 'none';
    } else if (picking4th) {
      fourthWrap.style.display = '';
      fourthBtn.style.display = 'none';
      fourthHint.style.display = '';
    } else if (n === MAX) {
      fourthWrap.style.display = 'none';
    } else {
      fourthWrap.style.display = 'none';
    }

    // Purchase type & pricing
    if (n >= MIN) {
      purchaseType.style.display = '';
      var total = 0;
      selections.forEach(function (s) { total += s.price; });
      priceOnetime.textContent = money(total);
      priceSubscribe.textContent = money(total * (1 - SUBSCRIBE_DISCOUNT));
    } else {
      purchaseType.style.display = 'none';
    }

    // Manage selling plan hidden input
    var purchaseSelected = picker.querySelector('input[name="fk_purchase_type"]:checked');
    var sellingPlanInput = picker.querySelector('input[name="selling_plan"]');
    if (purchaseSelected && purchaseSelected.value === "subscribe") {
      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = "selling_plan";
        picker.appendChild(sellingPlanInput);
      }
      sellingPlanInput.value = SELLING_PLAN_ID;
    } else if (sellingPlanInput) {
      sellingPlanInput.remove();
    }

    if (n >= MIN && purchaseSelected) {
      errorEl.textContent = '';
      enableAddToCart();
    } else if (n >= MIN && !purchaseSelected) {
      errorEl.textContent = 'Please select a delivery option.';
      disableAddToCart();
    } else {
      disableAddToCart();
      if (n > 0 && n < MIN) {
        errorEl.textContent = 'Pick ' + (MIN - n) + ' more jar' + (MIN - n > 1 ? 's' : '') + '.';
      } else {
        errorEl.textContent = '';
      }
    }
  }

  function disableAddToCart() {
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.setAttribute('title', 'Please select 3 jars first');
    }
  }

  function enableAddToCart() {
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute('title');
    }
  }

  function handleFlavourClick(e) {
    var btn = e.target.closest('.fk-flavour');
    if (!btn) return;

    var flavour = btn.getAttribute('data-flavour');
    var price = parseFloat(btn.getAttribute('data-price'));
    var n = selections.length;

    if (picking4th && n === MIN) {
      selections.push({ name: flavour, price: price });
      picking4th = false;
      updateUI();
      return;
    }

    if (n < MIN) {
      selections.push({ name: flavour, price: price });
    } else {
      var idx = -1;
      for (var i = 0; i < selections.length; i++) {
        if (selections[i].name === flavour) { idx = i; break; }
      }
      if (idx !== -1) {
        selections.splice(idx, 1);
        picking4th = false;
      }
    }

    updateUI();
  }

  function handleRemove(e) {
    var btn = e.target.closest('.fk-flavour');
    if (!btn) return;

    var flavour = btn.getAttribute('data-flavour');
    for (var i = 0; i < selections.length; i++) {
      if (selections[i].name === flavour) {
        e.preventDefault();
        selections.splice(i, 1);
        picking4th = false;
        updateUI();
        return;
      }
    }
  }

  function handlePurchaseType() {
    picker.querySelectorAll('input[name="fk_purchase_type"]').forEach(function (r) {
      r.addEventListener('change', function () {
        optOnetime.classList.toggle('fk-option--active', r.value === 'onetime');
        optSubscribe.classList.toggle('fk-option--active', r.value === 'subscribe');
        updateUI();
      });
    });
  }

  function init() {
    picker = document.getElementById('fk-picker');
    if (!picker) return;

    grid = document.getElementById('fk-grid');
    counter = document.getElementById('fk-counter');
    countEl = document.getElementById('fk-count');
    errorEl = document.getElementById('fk-error');
    clearBtn = document.getElementById('fk-clear');
    fourthWrap = document.getElementById('fk-fourth');
    fourthBtn = document.getElementById('fk-fourth-btn');
    fourthHint = document.getElementById('fk-fourth-hint');
    purchaseType = document.getElementById('fk-purchase-type');
    optOnetime = document.getElementById('fk-opt-onetime');
    optSubscribe = document.getElementById('fk-opt-subscribe');
    priceOnetime = document.getElementById('fk-price-onetime');
    priceSubscribe = document.getElementById('fk-price-subscribe');
    prop1 = document.getElementById('fk-prop-1');
    prop2 = document.getElementById('fk-prop-2');
    prop3 = document.getElementById('fk-prop-3');
    prop4 = document.getElementById('fk-prop-4');

    var form = picker.closest('form') || document.querySelector('product-form-component form');
    if (form) {
      addToCartBtn = form.querySelector('[name="add"], [ref="addToCartButton"]');
    }
    if (!addToCartBtn) {
      addToCartBtn = document.querySelector('[ref="addToCartButton"]');
    }

    picker.style.display = '';
    disableAddToCart();

    grid.addEventListener('click', handleFlavourClick);
    grid.addEventListener('contextmenu', handleRemove);

    clearBtn.addEventListener('click', function () {
      selections = [];
      picking4th = false;
      // Reset purchase type radios
      picker.querySelectorAll('input[name="fk_purchase_type"]').forEach(function (r) { r.checked = false; });
      optOnetime.classList.remove('fk-option--active');
      optSubscribe.classList.remove('fk-option--active');
      updateUI();
    });

    fourthBtn.addEventListener('click', function () {
      picking4th = true;
      updateUI();
    });

    handlePurchaseType();

    if (form) {
      form.addEventListener('submit', function (e) {
        if (selections.length < MIN) {
          e.preventDefault();
          e.stopPropagation();
          errorEl.textContent = 'Please select at least 3 jars before adding to cart.';
          grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }, true);
    }

    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () {
    var el = document.getElementById('fk-picker');
    if (el && !el.__fkBound) { el.__fkBound = true; init(); }
  }).observe(document.body, { childList: true, subtree: true });
})();
